import { FC } from "react";
import { AdminOrganizationResDto } from "service/api/estabrookSchemas";
import WarningConfirmDialog from "./WarningConfirmDialog";

export interface OrganizationDeleteConfirmDialogProps {
  organization: AdminOrganizationResDto | null;
  isSubmitting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const OrganizationDeleteConfirmDialog: FC<
  OrganizationDeleteConfirmDialogProps
> = ({ organization, isSubmitting, onConfirm, onCancel }) => (
  <WarningConfirmDialog
    open={Boolean(organization)}
    title="Delete Organization"
    description={`Are you sure you want to delete ${organization?.name}?`}
    warningText="This will permanently remove all associated data and revoke access for all team members. This action cannot be undone."
    confirmLabel="Delete"
    isSubmitting={isSubmitting}
    onConfirm={onConfirm}
    onCancel={onCancel}
    confirmTestId="confirm-delete-organization"
    cancelTestId="cancel-delete-organization"
  />
);

export default OrganizationDeleteConfirmDialog;
